module.exports = __webpack_public_path__ + "img/3.9d23a7c1.png";